export const CompanyMetaData = {
  '@context': 'https://schema.org',
  '@type': 'FinancialService',
  image: ['https://getjerry.com/imgs/favicon-256x256.png'],
  '@id': 'https://getjerry.com/',
  name: 'Jerry, Inc.',
  description: 'AI-powered Personal Insurance Shopper',
  url: 'https://getjerry.com',
  logo: 'https://getjerry.com/imgs/favicon-256x256.png',
  openingHours: 'Mo,Tu,We,Th,Fr 08:00-17:00',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '430 Sherman Ave',
    addressLocality: 'Palo Alto',
    addressRegion: 'CA',
    postalCode: '94306',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.4257435,
    longitude: -122.1463897,
  },
  telephone: '+1-833-445-3779',
  priceRange: '$',
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+1-833-445-3779',
      email: 'hi@getjerry.com',
      contactType: 'customer service',
      contactOption: 'TollFree',
      areaServed: 'US',
    },
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    bestRating: '5',
    ratingValue: '4.7',
    reviewCount: '4400',
  },
  sameAs: ['https://www.facebook.com/getjerrynow', 'https://www.linkedin.com/company/jerryinc'],
};
